import React from "react";
import { LogoutOutlined } from "@ant-design/icons";
import { Typography, Button, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import "./layout.css";
import logo from "./logo.png";

const { Text } = Typography;

function Layout(props) {

  let history = useHistory();

  function handleLogout() {
    props.removeToken();
    history.push("/login");
  }

  return (
    <div className="layout_container">
      <header className="layout_header">
        <a href="https://www.kandaovr.com/" target="_blank" rel="noreferrer">
          <img src={logo} width="100" alt="看到科技" />
        </a>
        {props.showLogout && (
          <Tooltip title="登出">
            <Button
              shape="circle"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
            />
          </Tooltip>
        )}
      </header>
      <div className="layout_content">{props.children}</div>
      <footer className="layout_footer">
        <Text type="secondary">Powered by Kandao Tech</Text>
      </footer>
    </div>
  );
}

export default Layout;
